import script from "./MoreBtnOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreBtnOptions.vue?vue&type=script&setup=true&lang=js"

import "./MoreBtnOptions.vue?vue&type=style&index=0&id=7c5f04bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5f04bc"]])

export default __exports__